import { render, staticRenderFns } from "./AuctionFeeForm.vue?vue&type=template&id=08aff38c&"
import script from "./AuctionFeeForm.vue?vue&type=script&lang=js&"
export * from "./AuctionFeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports